module.exports = __webpack_public_path__ + "img/delete.a8e6ab6c.svg";